import { InterceptContent } from './use-intercept.hook'
import { PictogramBuyingCar } from '@at/design-system-pictograms'
import React from 'react'
import { FilterName, InterceptType } from '../../../__generated__/fed-graphql-types'
import { Selected } from '../../../forms/hocs/selected-options'
import { getInterceptStorage, setInterceptStorage } from '../../search-listings/intercept.util'

// This type structure will be stored in local storage therefore removing any properties will be a breaking change
export type ValuationIntercept = {
    make: string
    model: string
    mileageFrom: string
}

function valuationMatches(
    previousSearches: ValuationIntercept[],
    makeParam: string,
    modelParam: string,
    mileageParam: string
) {
    return previousSearches?.some(
        (item) =>
            item.make.toLowerCase() === makeParam.toLowerCase() &&
            item.model.toLowerCase() === modelParam.toLowerCase() &&
            item.mileageFrom === mileageParam
    )
}

const getValuation = (selectedMap: Map<FilterName, Selected>): ValuationIntercept => {
    const make = selectedMap.get(FilterName.make)?.values[0] ?? ''
    const model = selectedMap.get(FilterName.model)?.values[0] ?? ''
    const mileageFrom = selectedMap.get(FilterName.min_mileage)?.values[0] ?? ''
    return { make, model, mileageFrom }
}

export const shouldShowValuationIntercept = (selectedFilters: Map<FilterName, Selected>) => {
    const { make: makeParam, model: modelParam, mileageFrom: mileageFromParam } = getValuation(selectedFilters)
    const valuationInterceptData = getInterceptStorage(InterceptType.VALUATION)
    if (valuationInterceptData && makeParam && modelParam && mileageFromParam) {
        return !valuationMatches(valuationInterceptData, makeParam, modelParam, mileageFromParam)
    }
    return true
}

export const getValuationInterceptContent = (
    position: number,
    selectedMap: Map<FilterName, Selected>
): InterceptContent => {
    const shouldUpdateLocalStorageForValuation = (
        previousSearches: ValuationIntercept[] | undefined,
        makeParam: string,
        modelParam: string,
        mileageParam: string
    ) => {
        if (previousSearches === undefined) return true
        return !valuationMatches(previousSearches, makeParam, modelParam, mileageParam)
    }

    const updateValuationInterceptLocalStorage = () => {
        const { make, model, mileageFrom } = getValuation(selectedMap)
        const currentIntercept: ValuationIntercept[] | undefined = getInterceptStorage(InterceptType.VALUATION)

        if (shouldUpdateLocalStorageForValuation(currentIntercept, make, model, mileageFrom)) {
            setInterceptStorage(InterceptType.VALUATION, {
                make,
                model,
                mileageFrom,
            })
        }
    }

    return {
        pictogram: <PictogramBuyingCar title={'Valuation intercept'} />,
        trackingLabel: 'intercept-valuation',
        componentNameLabel: `search-intercept-valuation-${position}`,
        handleClick: updateValuationInterceptLocalStorage,
    }
}
